import {
    getPatternByDeviceType,
    rowNames
} from './row-patterns';

export const getPattern = (deviceType) => [
    getPatternByDeviceType(rowNames.TRIPLE_ONE_THIRD, deviceType),
    getPatternByDeviceType(rowNames.NARROW, deviceType),
    getPatternByDeviceType(rowNames.TWO_THIRDS_AND_ONE_THIRD, deviceType),
    getPatternByDeviceType(rowNames.NARROW_REVERSE, deviceType),
    getPatternByDeviceType(rowNames.TRIPLE_ONE_THIRD, deviceType),
    getPatternByDeviceType(rowNames.ONE_THIRD_AND_TWO_THIRDS, deviceType),
];
